import React, { createContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
// import { TabView, TabPanel } from 'primereact/tabview';
import CustomGreetingFilter from '../../../components/metricsScoreCard/CustomGreetingFilter';
import NotificationList from '../../../components/notificationList/NotificationList';
import { MetricsScoreCard } from '../../../components/metricsScoreCard/MetricsScoreCard';
import MetricRankings from '../metricRankings/metricRankings';
import { ShoutOutCarousel } from '../../coaching/toDoView/shoutOutCarousel/ShoutOutCarousel';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsAllowCoachingActionModel,
    selectIsPseudoSupervisor,
    selectIsUserinPercepta,
} from '../../../pages/login/authSlice';
import { NotificationItem } from '../../../components/notificationList/types';
import {
    useGetEmployeeNotificationsQuery,
    useUpdateNotificationMutation,
} from '../../header/notifications/notificationSlice';
import { getRole } from '../../../utils/roleUtils';
import { useGetShoutOutCarouselQuery } from '../../coaching/toDoView/toDoViewSlice';
import { TeamLeadDueTodos } from '../../../components/teamLeadDueTodos/TeamLeadDueTodos';
import { useGetGamePlanQuery } from '../../gamePlan/gamePlanSlice';
import { GameplanLandingPage } from '../gameplanLandingPage/GameplanLandingPage';
import { ApprovalLandingPage } from '../approvalLandingPage/ApprovalLandingPage';
import ServiceNowApprovalsList from '../../../components/serviceNowApprovalsList/ServiceNowApprovalsList';
// import { ScorecardPizzaTracker } from '../../../components/scorecardPizzaTracker/ScorecardPizzaTracker';
// import { PayPeriodParticipantLandingPage } from '../payPeriodParticipantLandingPage/PayPeriodParticipantLandingPage';
import CoachingActionPlanDashboard from '../../coachingAction/coachingActionPlanDashboard/CoachingActionPlanDashboard';
import './teamLeadLandingPage.scss';

export const TLLandingContext = createContext({ viaPage: '' });

export const TeamLeadLandingPage = () => {
    const isUserinPercepta = useSelector(selectIsUserinPercepta);
    const isAllowCoachingActionModel = useSelector(selectIsAllowCoachingActionModel);
    const tlLandingContextValue = useMemo(() => ({ viaPage: 'TLLandingPage' }), []);
    const loggedUser = useSelector(selectCurrentUser);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [notifications, setNotifications] = useState<NotificationItem[]>([]);
    const [UpdateNotification] = useUpdateNotificationMutation();
    const [inputMonth, setInputMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setInputYear] = useState(new Date().getFullYear());
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [scorecardVersion, setScorecardVersion] = useState<number>(0);
    const [calendarDate, setCalendarDate] = useState(new Date());
    const [scorecardName, setScorecardName] = useState<string>('');
    const [askNowCount, setAskNowCount] = useState(0);

    const { data: employeeNotifications, isFetching: employeeNotificationsFetching } =
        useGetEmployeeNotificationsQuery({ employeeNumber: loggedEmpNum }, { skip: !loggedEmpNum });

    const { data: shoutOuts } = useGetShoutOutCarouselQuery({
        employeeNumber: loggedEmpNum,
        employeeRole: getRole(userMngrRole, isPseudoSupervisor),
    });

    const { data: gamePlanData } = useGetGamePlanQuery(
        {
            employeenumber: loggedEmpNum?.toString(),
        },
        {
            skip: !loggedEmpNum,
        }
    );

    useEffect(() => {
        if (!employeeNotificationsFetching) {
            if (employeeNotifications?.data?.length > 0) setNotifications(employeeNotifications.data);
            else setNotifications([]);
        }
    }, [employeeNotifications]);

    return (
        <TLLandingContext.Provider value={tlLandingContextValue}>
            <div className="landing-page-wrapper">
                <div className="card bg-body rounded mt-3 border-0 homepagebody">
                    {/* Greeting and Filter */}
                    <div className="row mb-3">
                        <h3 className="homePageText">Welcome Back {loggedUser}!</h3>
                        <CustomGreetingFilter
                            inputmonth={inputMonth}
                            setInputMonth={setInputMonth}
                            inputyear={inputYear}
                            setInputYear={setInputYear}
                            scorecardVersionValue={setScorecardVersion}
                            calendarDate={calendarDate}
                            setCalendarDate={setCalendarDate}
                            scorecardNameValue={setScorecardName}
                        />
                    </div>

                    {/* Main Grid */}
                    <div className="full-height-row">
                        {/* Left Column */}
                        <div className="left-column-wrapper">
                            {/* ToDos + Notifications */}
                            <div className="card shadow bg-body border-0 rounded-4 todo-notification-card">
                                <TeamLeadDueTodos />
                            </div>

                            {/* Metrics */}
                            <div className="card shadow bg-body border-0 rounded-4">
                                <div style={{ fontSize: '1.25rem', padding: '0.5rem 0.5rem 0', color: '#3F5765' }}>My Metrics</div>
                                <div className="metrics-section">
                                    <MetricsScoreCard
                                        agentnumber={loggedEmpNum}
                                        scorecardVersion={scorecardVersion}
                                        inputmonth={inputMonth}
                                        inputyear={inputYear}
                                    // isPayoutMetric={false}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="right-column">
                            <div
                                className="p-card card shadow bg-body border-0 ranking-list-container"
                                style={{ borderRadius: '25px' }}
                            >
                                <div className="landing-page-ranking">
                                    <MetricRankings
                                        empNum={loggedEmpNum}
                                        inputMonth={inputMonth}
                                        inputYear={inputYear}
                                        scorecardVersionID={scorecardVersion}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="card shadow bg-body border-0 rounded-4 todo-notification-card mt-3">
                        <div className="todo-notification-content h-100">
                            {isUserinPercepta !== true && isAllowCoachingActionModel !== true && (
                                <div id="tl-landingpage-gameplan" className="notification-column ps-2">
                                    <div className="section-header px-3 pt-3">Gameplan</div>
                                    <GameplanLandingPage gamePlan={gamePlanData} />
                                </div>
                            )} */}
                    {/* Approvals section */}
                    {/* <div className="notification-column ps-2">
                                <div className="section-header px-3 pt-0">Approvals</div>
                                {scorecardName !== '' && (
                                    <div
                                        className="section-header text-end fst-italic pt-0"
                                        style={{ fontWeight: 400, marginRight: '5rem' }}
                                    >
                                        Specific for {scorecardName}
                                    </div>
                                )}
                                <ApprovalLandingPage
                                    inputMonth={inputMonth}
                                    inputYear={inputYear}
                                    scorecardVersionID={scorecardVersion}
                                />
                            </div>
                        </div>
                    </div> */}
                    {isUserinPercepta === true || isAllowCoachingActionModel === true ? (
                        <div className="card shadow bg-body border-0 rounded-4 mt-3" style={{ display: 'flex', flexDirection: 'column' }}>
                            <CoachingActionPlanDashboard
                                inputmonth={inputMonth}
                                inputyear={inputYear}
                            />
                        </div>
                    ) : (
                        <div className="card shadow bg-body border-0 rounded-4 todo-notification-card mt-3" style={{ display: 'flex', flexDirection: 'column' }}>
                            <div id="tl-landingpage-gameplan" className="notification-column ps-2">
                                <div className="section-header px-3 pt-3">Gameplan</div>
                                <GameplanLandingPage gamePlan={gamePlanData} />
                            </div>
                        </div>
                    )}
                    <div className="notification-column ps-2">
                        <div className="card shadow bg-body border-0 rounded-4 mt-3">
                            {/* <div className="section-header px-3 pt-0">Approvals</div> */}
                            <ApprovalLandingPage
                                inputMonth={inputMonth}
                                inputYear={inputYear}
                                scorecardVersionID={scorecardVersion}
                                scorecardName={scorecardName}
                            />
                        </div>
                    </div>
                    <div className={`full-height-row-shoutout-notification mt-3 ${askNowCount === 0 ? 'two-columns' : ''}`}>
                        <div
                            className="bg-body border-0 shoutout-wrapper"
                            style={{ borderRadius: '25px', width: '100%' }}
                        >
                            <ShoutOutCarousel shoutOuts={shoutOuts?.data || []} via="agent_landingpage" />
                        </div>
                        <div
                            className="p-card card shadow bg-body border-0 ranking-list-container"
                            style={{ borderRadius: '25px' }}
                        >
                            <div style={{ fontSize: '1.25rem', padding: '1rem 1rem 0.1rem', color: '#3F5765' }}>Alerts & Notifications</div>
                            <div className="border-0 rounded-4 mt-3">
                                <NotificationList
                                    gridLayout={askNowCount === 0}
                                    notifications={notifications}
                                    onNotificationRead={(id) => {
                                        const notification = {
                                            employeenumber: loggedEmpNum,
                                            isNotificationRead: true,
                                            notificationId: id,
                                            readAll: false,
                                        };
                                        UpdateNotification(notification)
                                            .unwrap()
                                            .then((res: any) => console.log('Marked as read', res))
                                            .catch((err: any) => console.error('Update failed', err));
                                    }}
                                />
                            </div>
                        </div>

                        {askNowCount > 0 && (
                            <div
                                className="p-card card shadow bg-body border-0 ranking-list-container"
                                style={{ borderRadius: '25px' }}
                            >
                                <div style={{ fontSize: '1.25rem', padding: '1rem 1rem 0.1rem', color: '#3F5765' }}>ASKNow Tickets</div>
                                <div className="border-0 rounded-4 mt-3">
                                    <ServiceNowApprovalsList setAskNowCount={setAskNowCount} />
                                </div>
                            </div>
                        )}

                        {askNowCount === 0 && (
                            <div style={{ display: 'none' }}>
                                <ServiceNowApprovalsList setAskNowCount={setAskNowCount} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </TLLandingContext.Provider >
    );
};
